import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { TimeframeEnum } from "./export-report-modal.declarations";

export const createExportHeader = (data) => {
  if (data.headerGroups && data.headerGroups[0]) {
    let headerRow = "",
      columns = data.headerGroups[0].headers,
      newLine = "\r\n",
      separator = ",";

    for (let i = 0; i < columns.length; i++) {
      headerRow += (i > 0 ? separator : "") + columns[i].Header;
    }
    return headerRow + newLine;
  }
  return "";
};

export const createExportColumns = (data) => {
  if (data.columns) {
    let headerRow = "",
      columns = data.columns,
      newLine = "\r\n",
      separator = ",";

    for (let i = 0; i < columns.length; i++) {
      headerRow += (i > 0 ? separator : "") + columns[i].label;
    }
    return headerRow + newLine;
  }
  return "";
};

export const createExportHeaderRows = (data) => {
  if (data) {
    let content = "",
      columns = data.headerGroups[0].headers,
      table = data.rows,
      newLine = "\r\n",
      separator = ",",
      dataField;

    for (const element of table) {
      for (let i = 0; i < columns.length; i++) {
        dataField = columns[i].id;
        content += (i > 0 ? separator : "") + `"${element.values[dataField] ?? ""}"`;
      }
      content += newLine;
    }
    return content;
  }
  return "";
};
export const createExportRows = (data) => {
  if (data) {
    let content = "",
      columns = data.columns,
      table = data.rows,
      newLine = "\r\n",
      separator = ",",
      dataField;

    for (const element of table) {
      for (let i = 0; i < columns.length; i++) {
        dataField = columns[i].id;
        content += (i > 0 ? separator : "") + `"${element[dataField] ?? ""}"`;
      }
      content += newLine;
    }
    return content;
  }
  return "";
};

export const getStartEndDates = (timeframe) => {
  dayjs.extend(utc);
  const workingDate = dayjs.utc();
  let startDate;
  let endDate;
  switch (timeframe) {
    case TimeframeEnum.Yesterday:
      startDate = workingDate.subtract(1, "day").startOf("day");
      endDate = workingDate.subtract(1, "day").endOf("day");
      break;
    case TimeframeEnum.ThisWeek:
      startDate = workingDate.startOf("week").add(1, "day");
      endDate = workingDate.endOf("week").add(1, "day");
      break;
    case TimeframeEnum.LastWeek:
      const lastWeekDay = workingDate.subtract(7, "day");
      startDate = lastWeekDay.startOf("week").add(1, "day");
      endDate = lastWeekDay.endOf("week").add(1, "day");
      break;
    default:
      startDate = workingDate.startOf("day");
      endDate = workingDate.endOf("day");
  }

  return {
    startDate: startDate.format("MM/DD/YYYY"),
    endDate: endDate.format("MM/DD/YYYY")
  };
};

export const formatDateRange = ({ startDate, endDate }) => {
  return {
    startDate: startDate.split("T")[0].split("-").join("/"),
    endDate: endDate.split("T")[0].split("-").join("/")
  };
};

export const getDateRangeString = (dateRange) => {
  const rangeDates = dateRange ? formatDateRange(getStartEndDates(dateRange)) : { startDate: null, endDate: null };
  let rangeString = "";
  if (rangeDates.startDate && rangeDates.endDate && rangeDates.startDate !== rangeDates.endDate) {
    rangeString = `${rangeDates.startDate} - ${rangeDates.endDate}`;
  }
  if (rangeDates.startDate && rangeDates.endDate && rangeDates.startDate === rangeDates.endDate) {
    rangeString = `${rangeDates.startDate}`;
  }
  return rangeString;
};
